import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { TextField, FormControl, Checkbox, FormControlLabel, FormGroup, withStyles } from "@material-ui/core";

const styles = theme => ({
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        marginTop: '5px'
    }
});

const SearchForm = props => {
    const { classes, handleChange, translations, search } = props;
    const [searchState, setSearchState] = useState({ showOnlyDefault: false, showOnlyFavorite: false, showOnlyWithHotKey: false, search: '' });
    const handleSearchChange = event => {
        switch (event.target.value) {
            case 'showOnlyDefault':
            case 'showOnlyFavorite':
            case 'showOnlyWithHotKey':
                setSearchState({ ...searchState, [event.target.value]: !searchState[event.target.value] });
                break;
            default:
        }

        if (event.target.name === 'search') {
            setSearchState({ ...searchState, search: event.target.value });
        }
    }

    useEffect(() => {
        handleChange(searchState, search.original);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchState, search.original]);

    return (
        <div className={classes.root}>
            <Formik
                enableReinitialize={true}
            >
                <form>
                    <TextField
                        name="search"
                        onChange={handleSearchChange}
                        placeholder={translations["search"] || "Search"}
                        label={translations["search"] || "Search"}
                        margin={"dense"}
                        fullWidth={true}
                    />
                    <FormControl className={classes.formControl} component="fieldset">
                        <FormGroup aria-label="position" row>
                            <FormControlLabel
                                control={<Checkbox value="showOnlyDefault" onChange={handleSearchChange} color="primary" />}
                                label={translations["show_only_default"] || "Show only default"}
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                control={<Checkbox value="showOnlyFavorite" onChange={handleSearchChange} color="primary" />}
                                label={translations["show_only_favorite"] || "Show only favorite"}
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                control={<Checkbox value="showOnlyWithHotKey" onChange={handleSearchChange} color="primary" />}
                                label={translations["show_only_with_hot_keys"] || "Show only with hot keys"}
                                labelPlacement="end"
                            />
                        </FormGroup>
                    </FormControl>
                </form>
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(SearchForm);
